import { useMemo } from 'react';
import { ComparePlanDTO, useComparePlansQuery } from '../../api/useComparePlansQuery';
import { AsyncComponentHookResultBase } from '../../../../../../../../Types/ComponentHookResult';

interface UseCompareTableArgs {
  clientId: string;
  planIds: string[];
}

export interface ComparePlan extends ComparePlanDTO {
  socialSecurityFilingAge: string | null;
  socialSecurityFilingAgeSpouse: string | null;
}

export const useCompareTable = ({
  clientId,
  planIds,
}: UseCompareTableArgs): AsyncComponentHookResultBase<ComparePlan[]> => {
  const queryInfo = useComparePlansQuery({ clientId, planIds });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    return queryInfo.data.map(plan => {
      return {
        ...plan,
        socialSecurityFilingAge: plan.socialSecurityFilingAgeYear
          ? `${plan.socialSecurityFilingAgeYear} ${
              plan.socialSecurityFilingAgeMonth && plan.socialSecurityFilingAgeMonth > 0
                ? `& ${plan.socialSecurityFilingAgeMonth} months`
                : ''
            }`
          : null,
        socialSecurityFilingAgeSpouse: plan.socialSecurityFilingAgeYearSpouse
          ? `${plan.socialSecurityFilingAgeYearSpouse} ${
              plan.socialSecurityFilingAgeMonthSpouse && plan.socialSecurityFilingAgeMonthSpouse > 0
                ? `& ${plan.socialSecurityFilingAgeMonthSpouse} months`
                : ''
            }`
          : null,
      };
    });
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
